import React from 'react'

const OutlineBadge = ({text,bgColor,textColor,className=''}) => {
  return (
    <div className={`px-2 py-[2px] ${bgColor} ${textColor} ${className}`}>
      <p className={`text-[10px] uppercase`}>{text}</p>   
    </div>
  )
}

export default OutlineBadge